import store from '@/store/store'
import { customAmplitude } from '@/utils/customAmplitude'
import { displayConfetti } from '@/utils/confettiAnimation'
import { SHOW_DOWNLOAD_APP_TIME_DURATION, ShowModalType } from '@/scenes/engine/common/constants'
import useModal from './useModal'

/**
 * The app prompt is scheduled from the download click, which is also when a
 * Super offer may take the modal slot and pause that download. Replacing the
 * offer is treated as cancellation, so the file is never produced.
 */
export function scheduleDownloadAppPrompt(
  openDownloadApp: () => void,
  readModalType: () => ShowModalType | null = () => store.getState().modal.showModalType,
): void {
  setTimeout(() => {
    if (readModalType() === ShowModalType.LIMITED_TIME_OFFER) return
    openDownloadApp()
    displayConfetti()
    customAmplitude('Get App Modal', { Source: '1st time' })
  }, SHOW_DOWNLOAD_APP_TIME_DURATION)
}

/**
 * Returns a callback that triggers the post-download confetti animation and
 * "Download App" modal prompt — but only the first time the user downloads.
 */
export function useDownloadConfetti(): () => void {
  const { setShowModalType } = useModal()

  return () => {
    if (localStorage.getItem('isDisplayedModalDownloadApp')) return
    scheduleDownloadAppPrompt(() => setShowModalType(ShowModalType.DOWNLOAD_APP))
  }
}
